module.exports = __webpack_public_path__ + "img/NOT_icon.a41e63e5.svg";